import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '~/redux/api/middlewares';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Workouts', 'Exercises', 'Library', 'User'],
  endpoints: () => ({}),
});
